document.addEventListener('DOMContentLoaded', function () {
  // FADE IN
  gsap.utils.toArray('[data-aos="fade-in"]').forEach((element) => {
    let delay = '0';
    if(element.hasAttribute('data-aos-delay')) {
      delay = parseFloat(element.getAttribute('data-aos-delay')/1000);
    }
    gsap.fromTo(element, {
      opacity: 0,
    },
    {
      opacity: 1,
      delay: delay,
      duration: 1,
      scrollTrigger: {
        trigger: element,
        toggleActions: "restart reverse restart reverse"
      }
    }
    );
  });

  // FADE UP
  gsap.utils.toArray('[data-aos="fade-up"]').forEach((element) => {
    let delay = '0';
    if(element.hasAttribute('data-aos-delay')) {
      delay = parseFloat(element.getAttribute('data-aos-delay')/1000);
    }
    gsap.fromTo(element, {
      opacity: 0,
      y: 50,
    },
    {
      opacity: 1,
      y:0,
      delay: delay,
      duration: .5,
      scrollTrigger: {
        trigger: element,
        toggleActions: "restart reverse restart reverse"
      }
    }
    );
  });

  // FADE RIGHT
  gsap.utils.toArray('[data-aos="fade-right"]').forEach((element) => {
    let delay = '0';
    if(element.hasAttribute('data-aos-delay')) {
      delay = parseFloat(element.getAttribute('data-aos-delay')/1000);
    }
    gsap.fromTo(element, {
      opacity: 0,
      x: -100,
    },
    {
      opacity: 1,
      x:0,
      delay: delay,
      duration: .5,
      scrollTrigger: {
        trigger: element,
        toggleActions: "restart reverse restart reverse"
      }
    }
    );
  });

  // FADE LEFT
  gsap.utils.toArray('[data-aos="fade-left"]').forEach((element) => {
    let delay =parseInt(0);
    if(element.hasAttribute('data-aos-delay')) {
      delay = parseFloat(element.getAttribute('data-aos-delay')/1000);
    }
    gsap.fromTo(element, {
      opacity: 0,
      x: 100,
    },
    {
      opacity: 1,
      x:0,
      delay: delay,
      duration: .5,
      scrollTrigger: {
        trigger: element,
        toggleActions: "restart reverse restart reverse"
      }
    }
    );
  });

  // FALL DOWN
  gsap.utils.toArray('[data-aos="fall-down"]').forEach((element) => {
    let split = element.innerHTML.split("");
    let delay = 0;
    if(element.hasAttribute('data-aos-delay')) {
      delay = parseFloat(element.getAttribute('data-aos-delay')/1000);
    }
    element.innerHTML = '';

    split.forEach(line => {
      const newSpan = document.createElement("span");
      newSpan.style.display = "inline-block";
      newSpan.innerHTML = line;
      element.appendChild(newSpan);
    })

    for(let child of element.children) {
      if(child.tagName == 'SPAN') {
        gsap.set(child, {scale: 2, opacity: 0})
        gsap.to(child, {
          duration: 0.3,
          opacity: 1,
          delay: delay + 0.1,
          scrollTrigger: {
          trigger: element,
          toggleActions: "restart reverse restart reverse"
          }
        });
        delay = delay + 0.3;
        gsap.to(child, {
          duration: 0.1,
          scale: 1,
          delay: delay,
          scrollTrigger: {
          trigger: element,
          toggleActions: "restart reverse restart reverse"
          }
        });
      }
    }
  });

  // FADE UP LINE BY LINE
  gsap.utils.toArray('[data-aos="fade-up-lines"]').forEach((element) => {
    let split = element.innerHTML.split(/\r?\n|\r|\n/g);
    let delay = 0;
    if(element.hasAttribute('data-aos-delay')) {
      delay = parseFloat(element.getAttribute('data-aos-delay')/1000);
    }
    element.innerHTML = '';

    split.forEach(line => {
      const newSpan = document.createElement("span");
      newSpan.style.display = 'inline-block';
      newSpan.innerHTML = line;
      element.appendChild(newSpan);
    })

    for(let child of element.children) {
      if(child.tagName == 'SPAN') {
        gsap.fromTo(child, {
            opacity: 0,
            y: 100,
          },
          {
            opacity: 1,
            y:0,
            delay: delay,
            duration: .5,
            scrollTrigger: {
              trigger: element,
              toggleActions: "restart reverse restart reverse"
            }
          }
        );
        delay = delay + 0.1;
      }
    }
  });

  // ZOOM IN
  gsap.utils.toArray('[data-aos="zoom-in"]').forEach((element) => {
    let delay = '0';
    if(element.hasAttribute('data-aos-delay')) {
      delay = parseFloat(element.getAttribute('data-aos-delay')/1000);
    }
    gsap.fromTo(element, {
      scale: 0.6,
    },
    {
      scale: 1,
      delay: delay,
      duration: .3,
      scrollTrigger: {
        trigger: element,
        toggleActions: "restart reverse restart reverse"
      }
    }
    );
  });

  // NUMBER ANIMATION
  gsap.utils.toArray('[data-aos="number-increase"]').forEach((element) => {
    let targetTemperature = element.innerHTML;
    let currentTemperature;
    const apiKey = 'dee271f7fc85836e15a3a10f9e4ca236';

    navigator.geolocation.getCurrentPosition(async (position) => {
      const response = await fetch(`https://api.openweathermap.org/data/2.5/weather?lat=${position.coords.latitude}&lon=${position.coords.longitude}&units=imperial&appid=${apiKey}`);
      if (response.ok) {
        const weather = await response.json();
        currentTemperature = parseInt(weather.main.temp);
        element.innerHTML = currentTemperature;
      } else {
        element.innerHTML = '100';
      }

      gsap.set(element, {textContent: currentTemperature});
      gsap.to(element, {
        textContent: targetTemperature,
        duration: 1,
        delay: 1,
        snap: { textContent: 1 },
        ease: "power1.in",
        scrollTrigger: {
          trigger: element,
          toggleActions: "restart reverse restart reverse"
        }
      });
    });
  });
}, false);


// const SCROLL_ANIMATION_TRIGGER_CLASSNAME = 'scroll-trigger';
// const SCROLL_ANIMATION_OFFSCREEN_CLASSNAME = 'scroll-trigger--offscreen';
// const SCROLL_ZOOM_IN_TRIGGER_CLASSNAME = 'animate--zoom-in';
// const SCROLL_ANIMATION_CANCEL_CLASSNAME = 'scroll-trigger--cancel';

// // Scroll in animation logic
// function onIntersection(elements, observer) {
//   elements.forEach((element, index) => {
//     if (element.isIntersecting) {
//       const elementTarget = element.target;
//       if (elementTarget.classList.contains(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME)) {
//         elementTarget.classList.remove(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME);
//         if (elementTarget.hasAttribute('data-cascade'))
//           elementTarget.setAttribute('style', `--animation-order: ${index};`);
//       }
//       observer.unobserve(elementTarget);
//     } else {
//       element.target.classList.add(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME);
//       element.target.classList.remove(SCROLL_ANIMATION_CANCEL_CLASSNAME);
//     }
//   });
// }

// function initializeScrollAnimationTrigger(rootEl = document, isDesignModeEvent = false) {
//   const animationTriggerElements = Array.from(rootEl.getElementsByClassName(SCROLL_ANIMATION_TRIGGER_CLASSNAME));
//   if (animationTriggerElements.length === 0) return;

//   if (isDesignModeEvent) {
//     animationTriggerElements.forEach((element) => {
//       element.classList.add('scroll-trigger--design-mode');
//     });
//     return;
//   }

//   const observer = new IntersectionObserver(onIntersection, {
//     rootMargin: '0px 0px -50px 0px',
//   });
//   animationTriggerElements.forEach((element) => observer.observe(element));
// }

// // Zoom in animation logic
// function initializeScrollZoomAnimationTrigger() {
//   if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

//   const animationTriggerElements = Array.from(document.getElementsByClassName(SCROLL_ZOOM_IN_TRIGGER_CLASSNAME));

//   if (animationTriggerElements.length === 0) return;

//   const scaleAmount = 0.2 / 100;

//   animationTriggerElements.forEach((element) => {
//     let elementIsVisible = false;
//     const observer = new IntersectionObserver((elements) => {
//       elements.forEach((entry) => {
//         elementIsVisible = entry.isIntersecting;
//       });
//     });
//     observer.observe(element);

//     element.style.setProperty('--zoom-in-ratio', 1 + scaleAmount * percentageSeen(element));

//     window.addEventListener(
//       'scroll',
//       throttle(() => {
//         if (!elementIsVisible) return;

//         element.style.setProperty('--zoom-in-ratio', 1 + scaleAmount * percentageSeen(element));
//       }),
//       { passive: true }
//     );
//   });
// }

// function percentageSeen(element) {
//   const viewportHeight = window.innerHeight;
//   const scrollY = window.scrollY;
//   const elementPositionY = element.getBoundingClientRect().top + scrollY;
//   const elementHeight = element.offsetHeight;

//   if (elementPositionY > scrollY + viewportHeight) {
//     // If we haven't reached the image yet
//     return 0;
//   } else if (elementPositionY + elementHeight < scrollY) {
//     // If we've completely scrolled past the image
//     return 100;
//   }

//   // When the image is in the viewport
//   const distance = scrollY + viewportHeight - elementPositionY;
//   let percentage = distance / ((viewportHeight + elementHeight) / 100);
//   return Math.round(percentage);
// }

// window.addEventListener('DOMContentLoaded', () => {
//   initializeScrollAnimationTrigger();
//   initializeScrollZoomAnimationTrigger();
// });

// if (Shopify.designMode) {
//   document.addEventListener('shopify:section:load', (event) => initializeScrollAnimationTrigger(event.target, true));
//   document.addEventListener('shopify:section:reorder', () => initializeScrollAnimationTrigger(document, true));
// }
